module.exports = __webpack_public_path__ + "static/media/broker-step2.13a2da86.png";